export var ConversationStatusVoData;
(function (ConversationStatusVoData) {
    ConversationStatusVoData["OPEN"] = "OPEN";
    ConversationStatusVoData["CLOSE"] = "CLOSED";
})(ConversationStatusVoData || (ConversationStatusVoData = {}));
//# sourceMappingURL=conversation-status-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/chat/conversation-status-vo-data.js
// module id = 395
// module chunks = 14